import { Link } from "react-router-dom";
import { entries } from "@/mocks/entries";
import EntryCard from "@/components/feature/EntryCard";
import Reveal from "@/components/base/Reveal";
import { formatDate, formatHeat, getCategoryName } from "@/utils/content";

export default function FeaturedSection() {
  const sorted = [...entries].sort((a, b) => b.heat - a.heat);
  const [lead, ...rest] = sorted.slice(0, 5);

  return (
    <section className="border-y border-background-200/70 bg-background-100/60" aria-labelledby="home-featured-title">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-medium tracking-[0.25em] text-primary-600">TRENDING</p>
            <h2 id="home-featured-title" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              本周热门汇总
            </h2>
          </div>
          <Link
            to="/keywords"
            className="flex w-fit items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部索引
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid gap-6 lg:grid-cols-[1.1fr_1fr] lg:gap-10">
          <Reveal>
            <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
              <Link to={`/entry/${lead.id}`} className="block h-56 w-full overflow-hidden bg-background-200 md:h-72">
                <img
                  src={lead.cover}
                  alt={`${lead.title}配图`}
                  title={`${lead.persona}话题汇总配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </Link>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-accent-800">
                    {getCategoryName(lead.category)}
                  </span>
                  <span className="flex items-center gap-1 text-primary-600">
                    <i className="ri-fire-line" />
                    热度 {formatHeat(lead.heat)}
                  </span>
                  <span>{formatDate(lead.updated)} 更新</span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  <Link to={`/entry/${lead.id}`} className="transition-colors group-hover:text-primary-600">
                    {lead.title}
                  </Link>
                </h3>
                <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {lead.tags.map((tag) => (
                    <span key={tag} className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          </Reveal>

          <div className="flex flex-col">
            {rest.map((entry, index) => (
              <Reveal key={entry.id} delay={index * 60}>
                <EntryCard entry={entry} layout="row" rank={index + 2} />
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}